<div class="container">
  <div class="item-list">
    <div
      *ngFor="let user of this.state.users$ | async"
      (click)="editUser(user)"
      class="item"
    >
      <ion-label [ngClass]="{ deleted: user.isDeleted || user.isDeactivated }">
        {{ user.firstName }} {{ user.lastName }}
        <span *ngIf="user.isDeleted">(gelöscht)</span>
        <span *ngIf="user.isDeactivated">(deaktiviert)</span>
      </ion-label>
      <!--ion-icon
        (click)="openDeleteUserAlert(users)"
        size="small"
        name="trash-outline"
      ></ion-icon-->
    </div>
  </div>
  <div class="sum">
    {{ (this.state.users$ | async)?.length }} Mitarbeiter gefunden
  </div>
</div>
<!--ion-alert
    [isOpen]="isDeleteAlertOpen"
    header="Mitarbeiter löschen?"
    [buttons]="deleteButtons"
    (didDismiss)="setDeleteResult($event)"
  ></ion-alert-->
<ion-alert
  [isOpen]="isDeleteAlertOpen"
  subHeader="Diese Funktion ist noch nicht verfügbar"
  [buttons]="deleteButtons"
></ion-alert>
